import { useSelector, shallowEqual } from 'react-redux';
import { useMemo } from 'react';

export const useCalculatedDisplayMode = () => {
  const { displayMode, panels } = useSelector(
    (state) => ({
      displayMode: state.objects?.displayMode ?? [],
      panels: state.objects?.panels ?? [],
    }),
    shallowEqual
  );

  return useMemo(() => {
    return displayMode.map((elem, index) =>
      panels[index]?.width < 300 ? 'stack' : elem
    );
  }, [displayMode, panels]);
};
